import ApiService from "src/services/ApiService";
import localStorage from "src/utils/local-storage";
const user = localStorage.get("_user");

const getSession = () => {
  return new Promise((resolve, reject) => {
    ApiService.get(`/locks?label=home`).then((data) => {
      if (data && data.length > 0) {
        resolve(data[0]);
      } else {
        ApiService.post("/locks", { label: "home" }).then((data2) => {
          resolve(data2);
        });
      }
    });
  });
};

const updateSession = (lock, value, takeOver = false) => {
  localStorage.set("editingHomepage", value);
  localStorage.set("lock", lock);
  ApiService.put(`/locks/${lock.id}`, { 
    value, 
    lockAt: value ? new Date() : null,
    takeOver 
  });
};

const deleteSession = () => {
  const lock = localStorage.get("lock");
  if (lock) {
    updateSession(lock, "");
  }
}

export { getSession, updateSession, deleteSession };
